import {reactFetchJSON, type JSONRequestInit} from '@github-ui/verified-fetch'
import {buildItemPickersBulkActionsUrl} from '@github-ui/item-picker-base/api/urls'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import type {BulkActionQueryTarget} from '@github-ui/item-picker-base/ItemPicker'
import {UpdateIssuesBulk, UpdateIssuesBulkByQuery} from '@github-ui/server-persisted-queries'
import type {UpdateIssuesBulkMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulk'
import type {UpdateIssuesBulkByQueryMutation} from '@github-ui/server-persisted-queries/types/UpdateIssuesBulkByQuery'

type UpdateIssueMilestoneBulkRequestBase = {
  ids: string[]
  queryTarget?: BulkActionQueryTarget
}

type UpdateIssueMilestoneBulkRequestWithMilestoneId = UpdateIssueMilestoneBulkRequestBase & {
  milestoneId: string
}

type UpdateIssueMilestoneBulkRequestWithClearMilestone = UpdateIssueMilestoneBulkRequestBase & {
  clearMilestone: true
}

export type UpdateIssueMilestoneBulkRequest =
  | UpdateIssueMilestoneBulkRequestWithMilestoneId
  | UpdateIssueMilestoneBulkRequestWithClearMilestone

export type UpdateIssueMilestoneBulkResponse = GraphQLResponse<
  Partial<UpdateIssuesBulkMutation & UpdateIssuesBulkByQueryMutation>
>

export async function apiUpdateIssueMilestoneBulk(
  request: UpdateIssueMilestoneBulkRequest,
): Promise<UpdateIssueMilestoneBulkResponse> {
  const requestUrl = buildItemPickersBulkActionsUrl()
  const body: Record<string, unknown> = {
    ...(request.queryTarget ?? {ids: request.ids}),
    queryId: request.queryTarget ? UpdateIssuesBulkByQuery : UpdateIssuesBulk,
  }

  if ('milestoneId' in request) {
    body['milestoneId'] = request.milestoneId
  } else {
    body['clearMilestone'] = request.clearMilestone
  }
  const init: JSONRequestInit = {
    method: 'POST',
    body,
  }
  const response = await reactFetchJSON(requestUrl, init)
  return response.json() as Promise<UpdateIssueMilestoneBulkResponse>
}
